/**
 * Mapping automatique des samples audio
 * Aligné avec metronome-engine.js et i18n.js
 */

export const AUDIO_SAMPLES = {
    "classic": {
        "strong": "assets/classic.wav",
        "weak": "assets/classic-weak.wav",
        "subdivision": "assets/classic-sub.wav"
    },
    "snap": {
        "strong": "assets/snap.wav",
        "weak": "assets/snap-weak.wav", 
        "subdivision": "assets/snap-sub.wav"
    },
    "perc": {
        "strong": "assets/perc.wav",
        "weak": "assets/perc-weak.wav",
        "subdivision": "assets/perc-sub.wav"
    },
    "wood": {
        "strong": "assets/wood.wav",
        "weak": "assets/wood-weak.wav",
        "subdivision": "assets/wood-sub.wav"
    }
};

// Configuration par défaut des types de sons
export const SOUND_CONFIG = {
    classic: {
        name: "classic_tick",
        description: "Classic metronome tick sound"
    },
    snap: {
        name: "finger_snap", 
        description: "Finger snap sound"
    },
    perc: {
        name: "percussive_hit",
        description: "Percussive hit sound"
    },
    wood: {
        name: "wood_block",
        description: "Wood block sound"
    }
};

// Validation des fichiers audio requis
export function validateAudioFiles() {
    const requiredFiles = [];
    
    Object.entries(AUDIO_SAMPLES).forEach(([soundType, variants]) => {
        Object.values(variants).forEach(filePath => {
            requiredFiles.push(filePath);
        });
    });
    
    return requiredFiles;
}
